/**
 * A mobile as the API stores it: the 10-digit Indian national number. Strips spaces, dashes,
 * brackets and a `+91` / `0091` / `91` / `0` prefix, and leaves anything else for the schema to
 * judge. Mirrors the backend's `normalizeMobile`.
 */
export function normalizeMobile(value: string): string {
  const compact = value.trim().replace(/[\s\-().]/g, '');
  const prefixed = /^(?:\+91|0091|91|0)(\d{10})$/.exec(compact);
  return prefixed?.[1] ?? compact;
}

/** 10 digits, starting 6, 7, 8 or 9 — the same rule the API enforces. */
export const MOBILE_PATTERN = /^[6-9]\d{9}$/;
